module.exports = __webpack_public_path__ + "img/IconChevronDown.dac7f704.svg";